import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHomeRoundDoor: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconHomeRoundDoor"><Path d="M12 2.86548L3 8.49048V20.9999H9.5V16.7499C9.5 15.3692 10.6193 14.2499 12 14.2499C13.3807 14.2499 14.5 15.3692 14.5 16.7499V20.9999H21V8.49048L12 2.86548Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHomeRoundDoor;
